// extracted by mini-css-extract-plugin
module.exports = {"rankWrapper":"QjQnIWif","styledTableHeader":"RJOrLp6u","footerRow":"gIcMDJiy","styledTanStackTableRoot":"g3SFlPWM"};